module.exports = __webpack_public_path__ + "img/small_whale04.b0172b37.jpg";